import React from "react";
import { Badge } from "../../../ui/badge";
import { cn, isLocationMatch } from "../../../../helper/utilityHelper";
import { Link, useLocation } from "react-router-dom";
import PremiumIcon from "./Premium-Icon";
import NewTag from "../common/NewTag";

const SingleMenuItem = ({ item, collapsed, hovered }) => {
    const { badge, href, title, isPremium } = item;
    const location = useLocation();
    const locationName = location.pathname;

    return (
        <Link to={href}>
            <>
                {!collapsed || hovered ? (
                    <div
                        className={cn(
                            "flex gap-3 group  text-default-700 dark:text-default-950  font-medium  text-sm capitalize px-[10px] py-2 rounded cursor-pointer hover:bg-primary hover:text-primary-foreground",
                            {
                                "bg-primary text-primary-foreground": isLocationMatch(
                                    href,
                                    locationName
                                ),
                            }
                        )}
                    >
                        <span className="flex-grow-0">
                            <item.icon className="w-5 h-5  " />
                        </span>
                        <div className="text-box flex-grow">{title}</div>
                        {item.isNew && <NewTag className="ml-2" />}
                        {isPremium && <div className="flex items-center justify-center w-6 h-6"><PremiumIcon /></div>}
                        {badge && <Badge className=" rounded">{item.badge}</Badge>}
                    </div>
                ) : (
                    <div className="relative">
                        <span
                            className={cn(
                                "h-12 w-12 mx-auto rounded-md  transition-all duration-300 inline-flex flex-col items-center justify-center  relative  ",
                                {
                                    "bg-primary text-primary-foreground ": isLocationMatch(
                                        href,
                                        locationName
                                    ),
                                    " text-default-600   ": !isLocationMatch(href, locationName),
                                }
                            )}
                        >
                            <item.icon className="w-6 h-6" />
                        </span>
                        {item.isNew && (
                            <div className="absolute -top-1 -right-1">
                                <NewTag className="text-xs px-1 py-0.5" />
                            </div>
                        )}
                    </div>
                )}
            </>
        </Link>
    );
};

export default SingleMenuItem;
